import {
  DEFAULT_LEGAL_TEXT_KEY,
  resolveConfigurableTextForLegalKey,
} from "@/lib/utils";
import { useStore } from "@/store";
import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const ProblemPage = ({ textKey: textKeyProp }) => {
  const { t, i18n } = useTranslation();
  const { textKey: textKeyParam } = useParams();
  const rawKey = textKeyProp ?? textKeyParam ?? DEFAULT_LEGAL_TEXT_KEY;
  const activeTextKey =
    typeof rawKey === "string" && rawKey.trim() !== ""
      ? rawKey.trim()
      : DEFAULT_LEGAL_TEXT_KEY;
  const rawConfigurableTexts = useStore((state) => state.configurableTexts);
  const configurableTexts = Array.isArray(rawConfigurableTexts)
    ? rawConfigurableTexts
    : Array.isArray(rawConfigurableTexts?.data)
      ? rawConfigurableTexts.data
      : [];
  const [activeTexts, setActiveTexts] = useState({ preText: "", postText: "" });

  useEffect(() => {
    if (!configurableTexts.length) return;

    const getActiveText = (texts) =>
      texts?.find((text) => text.language === i18n.language)?.text || "";

    // Resolución tolerante: el identificador guardado en la pregunta puede
    // diferir en mayúsculas/espacios del `type` de la política, o ser su título.
    const homeTexts = resolveConfigurableTextForLegalKey(
      configurableTexts,
      activeTextKey,
      i18n.language,
    );

    if (homeTexts) {
      setActiveTexts({
        preText: getActiveText(homeTexts.preTexts || []),
        postText: getActiveText(homeTexts.postTexts || []),
      });
    } else {
      setActiveTexts({ preText: "", postText: "" });
    }
  }, [configurableTexts, i18n.language, activeTextKey]);

  return (
    <React.Fragment>
      {/* El título ahora es activeTexts.preText, sanitizado */}
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            activeTexts?.preText || t("ClientLayout.terms.title"),
          ),
        }}
      />
      {/* El contenido dentro del div será activeTexts.postText, sanitizado */}
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(activeTexts?.postText || ""),
        }}
      />
    </React.Fragment>
  );
};

export default ProblemPage;
